import React from 'react';

const DnDHandle = () => (
  <svg width="11" height="1" viewBox="0 0 11 1" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="0.5" y1="0.5" x2="10.5" y2="0.5" stroke="#787F88" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default DnDHandle;
